formatShortDetails